import _extends from'@babel/runtime/helpers/extends';import _objectWithoutProperties from'@babel/runtime/helpers/objectWithoutProperties';import React from'react';import PropTypes from'prop-types';import FormTextInput from'../FormTextInput/FormTextInput.js';import FormElement from'../FormElement/FormElement.js';import {validMUXMobileNumber}from'../../utils/validation.js';function FormMobileInput(props) {
  var id = props.id,
    label = props.label,
    value = props.value,
    onChange = props.onChange,
    disabled = props.disabled,
    otherProps = _objectWithoutProperties(props, ["id", "label", "value", "onChange", "disabled"]);
  var mobileFullNumber = value.fullPhoneNumber === undefined ? '' : value === null || value === void 0 ? void 0 : value.fullPhoneNumber;
  var handleChange = function handleChange(val) {
    var updatedValue = {
      countryCode: '+1',
      phoneNumber: val,
      fullPhoneNumber: "+1 ".concat(val)
    };
    onChange(updatedValue);
  };
  return /*#__PURE__*/React.createElement(FormElement, null, /*#__PURE__*/React.createElement(FormTextInput, _extends({}, otherProps, {
    id: id,
    mask: "(999)999-9999",
    placeholder: "( _ _ _ ) _ _ _ - _ _ _ _",
    validations: validMUXMobileNumber,
    label: label,
    onChange: handleChange,
    value: value.phoneNumber,
    formattedValue: mobileFullNumber,
    callouts: true,
    disabled: disabled
  })));
}
process.env.NODE_ENV !== "production" ? FormMobileInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.shape({
    phoneNumber: PropTypes.string,
    countryCode: PropTypes.string,
    fullPhoneNumber: PropTypes.string
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
} : void 0;
FormMobileInput.defaultProps = {
  disabled: false
};export{FormMobileInput as default};